import "@aurodesignsystem/auro-header";
import "@aurodesignsystem/auro-button";
import "@aurodesignsystem/auro-input";
import "@aurodesignsystem/auro-background";
import "@alaskaairux/design-tokens/dist/tokens/CSSCustomProperties.css";
import "./Menu.scss";
import { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../providers/AuthProvider";
import { UserProfilePanel } from "../UserProfilePanel/UserProfilePanel";


export default function Menu() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);
  const { getAdminStatus,getMaintainerStatus,getReviewerStatus } = useContext(AuthContext);

  const adGroups = [getAdminStatus(), getMaintainerStatus(), getReviewerStatus()].filter(status => status.value).map(status => status.adGroupName);

  useEffect(() => {
    const handleClickOutside = (event:any) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsPopupOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside,true);
    return () => {
      document.removeEventListener('click', handleClickOutside,true);
    };
  }, [])
  

  const str = sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_OIDC_PROVIDER}:${process.env.REACT_APP_OIDC_CLIENT_ID}`);
  let userInitials = "G";
  let fetchedUsername = "Guest";
  let userStation = "";
  let userDeptCode = "";

  if (str !== null) {
    const oidcStorage = JSON.parse(str);
    fetchedUsername = oidcStorage.profile.name;
    userStation = oidcStorage.profile.locale;
    userDeptCode = oidcStorage.profile.department_code;

    const nameArray = fetchedUsername.split(' ');
    userInitials = nameArray.map(word => word.charAt(0).toLocaleUpperCase()).join('');
  }

  const handleIconClick = () => {
    setIsPopupOpen(!isPopupOpen);
    };

    

  return (
    <div className="Titlebar">
      <div className="item1">
        <header className="header">
          <auro-header>
            <span className="HeaderClass">M&E Delay List</span>
          </auro-header>
        </header>
      </div>
       
           
           
      <div className="item2">
      <span className="userHeader"
              role="button"
        tabIndex={0}
        aria-label="Open user menu"
        onClick={handleIconClick}
       onKeyDown={(e) => { if (e.key === 'Enter') { return } }}
      >
        {userInitials}
      </span>
      {isPopupOpen && (
        <div className="username-popup" ref={popupRef}>
          <UserProfilePanel 
            userName={fetchedUsername} 
            userStation={userStation} 
            adGroups={adGroups} 
            userDeptCode={userDeptCode} />
        </div>)
      }      
    </div>
   
             
           
    </div>
  );
}